"use strict";
/*
 * Membrane React package
 * {@link https://www.npmjs.com/package/@membranehq/react}
 * v0.29.2
 */
'use client';

function withSlotScopeClasses(scope, slots) {
  const result = {};
  for (const key in slots) {
    const v = slots[key];
    const hook = `${scope}__${key}`;
    if (v == null) result[key] = [hook];
    else if (typeof v === "string") result[key] = [hook, v];
    else result[key] = [hook, ...v];
  }
  return result;
}

export { withSlotScopeClasses };
